import { pluralCount } from "@/helpers/helpers";
import PublicationDatePicker from "@/components/Posts/PublicationDatePicker";
import PUBLICATION_DATE_OPTIONS from "@/config/publication-date-options";
import { POSTS_CALL_TO_ACTION_TYPE } from "@/enums/posts.enum";
import { SCHEDULE_TYPE } from "@/enums/schedule-type";
import { FORMAT } from "@/config/date-format";
import moment from "moment";
import { PLAN_RESTRICTIONS } from "@/enums/plan-restrictions";
import { planRestrictionsCheck } from "@/helpers/plan-restrictions-check";
export const postFormMixin = {
  components: { PublicationDatePicker },
  props: {
    facilitiesCount: {
      type: Number,
      default: 0
    },
    editMode: {
      type: Boolean,
      required: false
    },
    type: {
      type: String
    }
  },
  data() {
    return {
      PUBLICATION_DATE_OPTIONS,
      items: Object.values(POSTS_CALL_TO_ACTION_TYPE),
      scheduleType: SCHEDULE_TYPE.NOW
    };
  },
  watch: {
    addTime(current) {
      this.$nextTick(() => {
        if (!current) {
          this.form.event.schedule.start_time = null;
          this.form.event.schedule.end_time = null;
        }
      });
    }
  },
  computed: {
    canPlanMarketingPublications() {
      return planRestrictionsCheck(
        PLAN_RESTRICTIONS.CAN_PLAN_MARKETING_PUBLICATIONS
      );
    },
    buttonLabel() {
      return this.facilitiesCount
        ? this.$t("message.posts.publishFor", [
            pluralCount(
              "message.pluralForms.facilityGenitive",
              this.facilitiesCount
            )
          ])
        : this.$t("message.posts.publish");
    },
    callToActionItems() {
      return this.items.map((item, index) => {
        return {
          name: this.$t(`message.posts.callToAction.${item}`),
          value: index + 1
        };
      });
    }
  },

  methods: {
    setDateAndTime(formData) {
      Object.entries(formData.event.schedule).map(([key, value]) => {
        if (key === "start_date" || key === "end_date") {
          formData.event.schedule[key] = {
            year: value ? moment(value).get("year") : null,
            month: value ? moment(value).get("month") + 1 : null,
            day: value ? moment(value).get("date") : null
          };
        } else {
          if (value) {
            this.addTime = true;
            const time = value ? value.split(":") : null;
            formData.event.schedule[key] = {
              hours: time ? parseInt(time[0]) : null,
              minutes: time ? parseInt(time[1]) : null
            };
          }
        }
      });
    },

    handlePublicationDateChange({ value, type }) {
      this.form.publish_at = value;
      this.scheduleType = type;
      this.$emit("schedule-type-changed", this.scheduleType);
    },

    setFormPreset(form) {
      if (!form.call_to_action) {
        form.call_to_action = {
          type: null,
          url: null
        };
      }
      return form;
    },

    handleDeleteImage() {
      this.$emit("delete");
    },

    uploadImage({ file, edited }) {
      if (file) {
        this.$emit("file", { file, edited });
      }
    },

    showPreview() {
      this.$validator.validate().then(isTrue => {
        if (isTrue) {
          this.setForm(this.form);
          this.$emit("preview");
        }
      });
    },

    submit() {
      this.$validator.validate().then(isTrue => {
        isTrue ? this.$emit("submit") : null;
      });
    }
  }
};
